<div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="secure-shopping about-fasinating-diamond">
        <p-carousel [value]="bannerImageList" [numVisible]="1" [numScroll]="1" [circular]="true"
            [showIndicators]="false" [responsiveOptions]="carouselResponsiveOptions">
            <ng-template let-banner pTemplate="item">
                <div class="product-item">
                    <div class="product-item-content">
                        <div class="p-mb-1 banner-item-main">
                            <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="container-fluid p-0">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">
                    <h1 class="title">About League</h1>
                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>

        </div>
    </div>
    <div class="box-container" fxLayout="column" style="min-height: 200px;">
        <div class="horizontal-container" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="stretch" fxFlex="auto">
            <div class="vertical-container" fxLayout="column" fxLayoutAlign="stretch" fxFlex="80%">
                <div class="box-title">Swiper</div>
                <div class="content-container" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                    <swiper class="swiper-container" fxFlex="auto" [config]="config" [disabled]="disabled"
                        (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                        (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                        <div *ngFor="let slide of slides " class="swiper-slide">
                            <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
                                <img [src]="slide.banner_image_src" alt="image" class="slide">
                            </div>
                            <h1>test</h1>
                        </div>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
    <div class="item" data-aos="example-anim1">1</div>
    <div class="item" data-aos="example-anim2">2</div>
    <div class="item" data-aos="example-anim3">3</div>
    <div class="item" data-aos="example-anim1">4</div>
    <div class="item" data-aos="example-anim2">5</div>
    <div class="item" data-aos="example-anim3">6</div>
    <div class="item" data-aos="example-anim1">7</div>
    <div class="item" data-aos="example-anim2">8</div>
    <div class="item" data-aos="example-anim3">9</div>

</div>